import { inject, Injectable } from '@angular/core';
import { AuthConfig, AuthConfigService } from '@rx-applications/shared/auth/data-access';

export type AuthConfigApiModel = AuthConfig;

@Injectable({
  providedIn: 'root',
})
export class AuthConfigFacade {
  #authConfig: AuthConfigService = inject(AuthConfigService);

  setAuthConfig(config: AuthConfigApiModel): void {
    this.#authConfig.config = config;
  }
}
